import React, { useEffect, useState } from 'react';
import './About.css';
import { Link } from 'react-router-dom';
import image from '../../Assets/about/home-about1.png';
import Footer from '../Common/Footer.jsx';
import { FaCheck, FaFileInvoiceDollar, FaThumbsUp, FaSmile } from "react-icons/fa";
import Navbar from '../Common/Navbar.jsx';
import AOS from 'aos';
import 'aos/dist/aos.css';

const StatItem = ({ icon, target, text }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = parseInt(target);
    if (start === end) return;

    const totalDuration = 2000;
    const incrementTime = (totalDuration / end) * 0.9;

    const timer = setInterval(() => {
      start += 1;
      setCount(start);
      if (start === end) clearInterval(timer);
    }, incrementTime);

    return () => clearInterval(timer);
  }, [target]);

  let symbol = '';
  if (text === 'Recommended' || text === 'Satisfaction') {
    symbol = '%';
  } else if (text === 'Tax Services') {
    symbol = '+';
  }

  return (
    <div className="ab-stat" data-aos="fade-up">
      <span className="ab-stat-icon">{icon}</span>
      <div>
        <h2>{count}{symbol}</h2>
        <p>{text}</p>
      </div>
    </div>
  );
};

const checklistItems = [
  'We are fast, convenient, and friendly, in every interaction.',
  'Our strong business focus improves your bottom line.',
  'We provide ongoing advice and instant support.',
];

const teamMembers = [
  { name: 'Ashok Manickam', role: 'Director of Operations' },
  { name: 'Brian Ebert', role: 'Tax Compliance Consultant' },
  { name: 'Johnathan', role: 'Transfer Pricing Consultant' },
];

const About = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div>
      {/* Hero banner */}
      <div className="about_container">
        <div className="about_bg">
          <Navbar />
          <div className="about_head_container">
            <div className="d-flex">


            </div>
            <h1>Who We Are
            </h1>
            <p className="about_head_subtitle">
              A dedicated team of tax and accounting professionals helping Canadians and businesses save money and stay compliant.
            </p>
          </div>
        </div>
      </div>

      {/* Intro — checklist-style instead of plain bullets */}
      <section className="ab-intro">
        <div className="ab-intro-text" data-aos="fade-right">
          <p className="heading1">ABOUT US</p>
          <h1>Oriental Business Solutions</h1>
          <p className="description">
            Oriental Business Solutions Inc. is a young and dynamic company, involved in providing customer satisfaction is of utmost importance, and we believe in a long-lasting client partnership based on mutual trust and respect.
          </p>
          <p className="description">
            Our quality service, competitive pricing, and competent and swift response enables the progress and advancement of our clients.
          </p>
          <p className="description">
            Whether you are a small business, an international student, an independent contractor, or someone just looking for personal taxes, Oriental Business Solutions is there to help you save your money and maximize your tax refunds. We can take care of all your accounting and bookkeeping needs.
          </p>
          <p className="description">
            Oriental Business Solutions has been serving individuals and businesses for several years. Starting off as a tax preparation and planning office, Oriental Business has grown to extend its service offerings — tax, insurance, investments, business advisory, incorporation, and mortgages.
          </p>
          <ul className="ab-check-list">
            {checklistItems.map((item) => (
              <li key={item}>
                <span className="ab-check-icon"><FaCheck /></span>
                {item}
              </li>
            ))}
          </ul>
        </div>
        <div className="ab-intro-media" data-aos="fade-left">
          <img src={image} alt="Tax Services" />
        </div>
      </section>

      {/* Stats — single bar with dividers instead of floating cards */}
      <section className="ab-stats-bar">
        <StatItem icon={<FaFileInvoiceDollar />} target="172" text="Tax Services" />
        <div className="ab-stat-divider" />
        <StatItem icon={<FaThumbsUp />} target="97" text="Recommended" />
        <div className="ab-stat-divider" />
        <StatItem icon={<FaSmile />} target="100" text="Satisfaction" />
      </section>

      {/* Story — bio only, no image */}
      <section className="ab-story">
        <div className="ab-story-text" data-aos="fade-left">
          <p className="heading1">WHO WE ARE</p>
          <h2>Ashok Manickam</h2>
          <p className="description">
            Ashok became a Certified General Accountant (CGA) in 2011, and with the unification of the accounting profession in Canada, is now a Chartered Professional Accountant (CPA). He is well rounded in personal taxes, corporate taxes, bookkeeping, and preparing year-end financial statements. His understanding of the Canadian financial market has been invaluable in assessing clients' needs, personal or corporate, for the past 12 years.
          </p>
          <p className="description">
            He also provides bookkeeping support to clients who perform accounting functions in-house, and is dedicated, hard-working, and well-liked by our clients and colleagues.
          </p>
          <p className="ab-story-quote">The right advice from our tax experts will save you time and money!</p>
        </div>
      </section>

      {/* Mission / Vision — side-by-side cards */}
      <section className="ab-mv-grid">
        <div className="ab-mv-card" data-aos="fade-up">
          <h4>Mission</h4>
          <p>
            Our mission is to empower our clients to achieve financial success through proactive and strategic tax planning. We strive to exceed expectations by delivering innovative solutions, personalized service, and unparalleled expertise.
          </p>
        </div>
        <div className="ab-mv-card" data-aos="fade-up" data-aos-delay="100">
          <h4>Vision</h4>
          <p>
            Our vision is to be the leading tax consulting firm known for integrity, professionalism, and client satisfaction. We aim to set the standard for excellence, continually adapting to meet the evolving needs of our clients and the regulatory environment.
          </p>
        </div>
      </section>

      {/* Team */}
      <section className="ab-team">
        <p className="heading1" style={{ textAlign: 'center' }}>OUR EXPERT CONSULTANTS</p>
        <h2 className="ab-team-title">Meet Our Expert Tax Consulting Team</h2>
        <div className="ab-team-grid">
          {teamMembers.map((member, idx) => (
            <div className="ab-team-card" key={member.name} data-aos="fade-up" data-aos-delay={idx * 80}>
              <div className="ab-team-avatar">{member.name.charAt(0)}</div>
              <h3>{member.name}</h3>
              <p>{member.role}</p>
              {member.email && (
                <Link to={`mailto:${member.email}`}>{member.email}</Link>
              )}
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;